// app/javascript/controllers/admin0_country_select_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "shortCode", "latitude", "longitude", "mapboxId", "preview"]
  static values = {
    countries: Array
  }

  selectCountry(event) {
    const isoCode = event.target.value
    if (!isoCode) {
      this.clearFields()
      return
    }

    const country = this.countriesValue.find(c => c.iso_a3 === isoCode)
    if (!country) return

    // Auto-remplir les champs du formulaire
    if (this.hasNameTarget) this.nameTarget.value = country.name
    if (this.hasShortCodeTarget) this.shortCodeTarget.value = country.iso_a3
    if (this.hasLatitudeTarget) this.latitudeTarget.value = country.label_y
    if (this.hasLongitudeTarget) this.longitudeTarget.value = country.label_x
    if (this.hasMapboxIdTarget) this.mapboxIdTarget.value = country.mapbox_id

    // Afficher la preview
    if (this.hasPreviewTarget) {
      this.previewTarget.innerHTML = `
        <div class="flex items-center mt-2 p-2 bg-blue-100 rounded-md">
          <svg class="w-4 h-4 text-blue-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
          <div class="text-sm text-blue-800">
            <strong>${country.name}</strong> (${country.iso_a3}) — ${country.continent}
            <span class="text-blue-600 ml-2">${country.label_y}, ${country.label_x}</span>
          </div>
        </div>
      `
      this.previewTarget.classList.remove('hidden')
    }
  }

  clearFields() {
    if (this.hasNameTarget) this.nameTarget.value = ''
    if (this.hasShortCodeTarget) this.shortCodeTarget.value = ''
    if (this.hasLatitudeTarget) this.latitudeTarget.value = ''
    if (this.hasLongitudeTarget) this.longitudeTarget.value = ''
    if (this.hasMapboxIdTarget) this.mapboxIdTarget.value = ''
    if (this.hasPreviewTarget) {
      this.previewTarget.innerHTML = ''
      this.previewTarget.classList.add('hidden')
    }
  }
}
